import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core/styles';

import Skeleton from '@material-ui/lab/Skeleton';

import { DIMENSIONS, COLORS } from './../../styles/constants';
import { useStyles } from './styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const FiltersPanelSkeleton = ({ numberOfRows }) => {
	const classes = useStyles();
	const theme = useTheme();

	return (
		<Paper style={{ border: `1px solid ${COLORS.BORDER}`, padding: 0 }}>
			<Grid xs container justifyContent="space-between" alignItems="center" className={classes.header}></Grid>

			{/* <Skeleton width="100%" /> */}

			<div className={classes.tableBarBottom}>
				<Skeleton width="100%" height={DIMENSIONS.SKELETON_TABLE_ROW_HEIGHT} />
			</div>
			<div className={classes.tableBarBottom}>
				<Skeleton width="100%" height={DIMENSIONS.SKELETON_TABLE_ROW_HEIGHT} />
			</div>
			<br />
			{[...Array(numberOfRows)].map((_e, index) => (
				<div key={'table-skeleton-row-' + index} className={classes.tableRowTitle}>
					<Skeleton width={`calc(100% - ${theme.spacing(3)})px`} height="100%" className={classes.skeleton} />
				</div>
			))}

			<div className={classes.tableBarBottom}>
				<Skeleton width="100%" height={DIMENSIONS.SKELETON_TITLE_HEIGHT} />
			</div>
		</Paper>
	);
};

FiltersPanelSkeleton.propTypes = {
	numberOfRows: PropTypes.number.isRequired,
	withFooter: PropTypes.bool
};

export default FiltersPanelSkeleton;
